// extracted by mini-css-extract-plugin
module.exports = {"container":"MetaMaskBtn_container__u6eZo","icon":"MetaMaskBtn_icon__3etw2","cta":"MetaMaskBtn_cta__3MZS0"};